import React, { Component } from 'react';
//import { observer } from 'mobx-react';
//import { withRouter } from 'react-router';
import { Scrollbars } from 'react-custom-scrollbars-2';
import {
  Modal, Message, Breadcrumb, Icon, List
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import WithRouter from '../Extensions/WithRouter';

class LitigatorDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMLD: props.isOpenMLD,
      litigatorData: props.litigatorData,
      litigatorName: props.litigatorName,
    };
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMLD, litigatorData, litigatorName } = this.props;
    if (prevProps.isOpenMLD !== isOpenMLD) {
      this.setState({
        isOpenMLD,
        litigatorData,
        litigatorName,
      });
    }
  }

  closeModal(e) {
    const { closeModal } = this.props;
    e.preventDefault();
    this.setState({
      isOpenMLD: false,
    });
    closeModal();
  }

  render() {
    const { t } = this.props;
    const { isOpenMLD, litigatorData, litigatorName } = this.state;
    return (
      <Modal open={isOpenMLD} onClose={this.closeModal}>
        {litigatorData.more_information ? (
          <div className="more_info_popup" style={{ borderRadius: '20px' }}>
            <div className="popup_header ">
              <h4 className="popup_name">
                <Icon name="info circle" />
                <Breadcrumb>
                  <Breadcrumb.Section>
                    {litigatorData.more_information.more_description.title}
                  </Breadcrumb.Section>
                </Breadcrumb>
              </h4>
              <a
                className="close_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            <Scrollbars
              renderTrackHorizontal={() => {
                return <div />;
              }}
              renderThumbHorizontal={() => {
                return <div />;
              }}
            >
              <div className="popup_contents">
                <div className="popup_content_wrap">
                  <Message
                    header="Description"
                    content={litigatorData.more_information.more_description.text}
                  />
                </div>
                {/*
                <div className="popup_content_wrap">
                  <p className="label">
                    {this.state.litigatorData.more_information.more_description.title}
                  </p>
                  <div className="value">
                    {this.state.litigatorData.more_information.more_description.text}
                  </div>
                </div>
                */}
                {litigatorData.more_information.url.length !== 0 ? (
                  <div className="popup_content_wrap">
                    {litigatorData.more_information.url.map((url) => {
                      return (
                        <List celled horizontal key={url.url.toString()}>
                          <List.Item style={{ borderLeft: 'none', paddingLeft: '0' }}>{url.title}</List.Item>
                          <List.Item style={{ borderLeft: 'none', borderRight: 'none' }}>
                            <a href={url.url} target="_blank" rel="noopener noreferrer">
                              {url.url}
                            </a>
                          </List.Item>
                        </List>
                      );
                    })}
                  </div>
                ) : null}
                {litigatorData.more_information.url.length !== 0 ? (
                  <div className="line" />
                ) : null}
                <div className="popup_content_wrap">
                  <p className="label">{t('modal.title.vulnerable_packages')}</p>
                </div>
                {litigatorData.more_information.inforce.length !== 0 ? (
                  <div className="popup_content_wrap">
                    <p className="label">
                      {litigatorData.more_information.inforce.title}
                    </p>
                    <table className="table" style={{ marginBottom: '30px', marginTop: '10px', tableLayout: 'fixed' }}>
                      <tbody>
                        {litigatorData.more_information.inforce.list.map(
                          (list) => {
                            return (
                              <tr key={list.toString()}>
                                <td
                                  style={{
                                    fontSize: '13px',
                                    wordBreak: 'break-all',
                                    padding: '5px 0 5px 0',
                                  }}
                                >
                                  {list}

                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : null}
                {litigatorData.avoid_infringement
                  && litigatorName === 'Patrick McHardy' && (
                  <div className="popup_content_wrap">
                    <p className="label">{litigatorData.avoid_infringement.title}</p>
                    {litigatorData.avoid_infringement.list.length !== 0
                      ? litigatorData.avoid_infringement.list.map((list) => {
                        return (
                          <div className="value" key={list.toString()}>
                            {list}
                          </div>
                        );
                      })
                      : null}
                  </div>
                )}
              </div>
            </Scrollbars>
          </div>
        ) : null}
      </Modal>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LitigatorDetailModal))));
